import { render, staticRenderFns } from "./_megah5.vue?vue&type=template&id=5a255ebe&lang=pug&"
import script from "./_megah5.vue?vue&type=script&lang=js&"
export * from "./_megah5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports